import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const PdfDocumentWidgetStaticSchema = BaseWidgetSchema(WidgetType.PdfDocument).extend({
  src: z.string(),
  title: z.string()
});

export type PdfDocumentWidgetStaticSchemaType = z.infer<typeof PdfDocumentWidgetStaticSchema>;
